import { Component, ElementRef, ViewChild, ChangeDetectorRef, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fn } from 'moment';
import { from, Observable } from 'rxjs';
import { PageBase, EmailType, EmailTemplateInfo, ContentFormat } from 't4core';
import { Editor, Toolbar } from 'ngx-editor';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';


@Component({
  selector: 'EmailTemplate',
  templateUrl: './EmailTemplate.html',
  styleUrls: ['./EmailTemplate.css']
})

export class EmailTemplate extends PageBase implements OnInit, OnDestroy {

  public contentTemplates: EmailTemplateInfo[];
  public selectedEmailType: string;
  public selectedKey: string;
  public emailTypes: any;
  public contentFormats: any;
  public filteredKeys: any;
  public friendlyName: string;
  public filteredFriendlyNames: EmailTemplateInfo[];
  public editorContent: any;
  public newContent = "<p></p>";
  public selectedIndex = 0;
  public showEditor: boolean = true;
  public data = new EmailTemplateInfo();
  public selectedTemplateId: string;
  public updatedFriendlyName: string;
  public updatedCondition: string;

  public form = new FormGroup({
    friendlyName: new FormControl('',[Validators.required]),
    condition: new FormControl('', [Validators.required]),
    format: new FormControl('', [Validators.required]),
    newContent: new FormControl('', [Validators.required])
  });

  public editor: Editor;
  public newEditor: Editor;
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear', 'indent', 'outdent'],
    ['superscript', 'subscript'],
    ['undo', 'redo'],
  ];

  constructor(el: ElementRef, private router: Router, private route: ActivatedRoute, private changeDetectorRef: ChangeDetectorRef) {
    super(el);
  }

  async ngOnInit() {
    this.editor = new Editor();
    this.newEditor = new Editor({
      keyboardShortcuts: true,
      inputRules: true,
    });
    var etoptions = Object.keys(EmailType);
    this.emailTypes = etoptions.slice(etoptions.length / 2);
    this.contentFormats = Object.entries(ContentFormat)
      .filter(([key, value]) => !isNaN(Number(value))) 
      .map(([key, value]) => ({ key: Number(value), value: key }));
    await this.getContentTemplates();
  }

  public async getContentTemplates() {
    this.contentTemplates = await this.Api.get<any[]>("Settings/GetEmailTemplatesByContextId");
  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }
  public onEmailTypeChange(event: any): void {
    this.selectedEmailType = event.value;
    if (this.selectedEmailType.startsWith("Insurance")) {
      this.selectedEmailType = this.selectedEmailType.toString().replace("Insurance", "Insurance.");
    }
    this.selectedEmailType = "Email." + this.selectedEmailType;
    var filteredTemplates = this.contentTemplates.filter(item => item.Key.includes(this.selectedEmailType)).map(x => x.Key);
    this.filteredKeys = [... new Set(filteredTemplates)];
    this.changeDetectorRef.detectChanges();
  }

  public async onKeyChange(event: any): Promise<void> {
    this.selectedKey = event.value;
    this.filteredFriendlyNames = await this.contentTemplates.filter(item => item.Key == this.selectedKey);
    this.editorContent = this.filteredFriendlyNames[0].Content;
    this.friendlyName = this.filteredFriendlyNames[0].FriendlyName;
    this.selectedTemplateId = this.filteredFriendlyNames[0].Id;
    this.updatedFriendlyName = this.filteredFriendlyNames[0].FriendlyName;
    this.updatedCondition = this.filteredFriendlyNames[0].Condition;
  }

  public async saveNewTemplate() {
    if (this.form.invalid) return;

    this.data.Key = this.selectedKey;
    this.data.Condition = this.form.get("condition")!.value;
    this.data.FriendlyName = this.form.get("friendlyName")!.value;
    this.data.Content = this.form.get("newContent")!.value;
    this.data.Format = parseInt(this.form.get("format")!.value);

    var token = this.UI.beginLoading("T4.Settings.EmailTemplate.Saving.ldrSavingEmailTemplate", "Saving email template", null);
    var res = await this.Api.post("/Settings/SaveEmailTemplate", this.data);
    this.UI.loaderCompleted(token);
    if (!res) return;
    await this.UI.alert("T4.Settings.EmailTemplate.SuccessSave", "Success!", "T4.Settings.EmailTemplate.SuccessSaveTemplateMsg", "The email template has been saved succesfully!");
    this.form.reset();
    //Update the tabs
    await this.getContentTemplates();
    this.filteredFriendlyNames = await this.contentTemplates.filter(item => item.Key == this.selectedKey);
  }
  onTabChange(event: any) {
    this.selectedIndex = event.index;
    this.friendlyName = event.tab.textLabel;
    if (this.friendlyName !== '+') {
      this.updatedFriendlyName = this.friendlyName;
      this.updatedCondition = this.filteredFriendlyNames[event.index].Condition;
      this.selectedTemplateId = this.filteredFriendlyNames[event.index].Id;
    }
    var fnames = this.contentTemplates.filter(item => item.Key == this.selectedKey);
    this.editorContent = fnames.filter(f => f.FriendlyName == this.friendlyName).map(x => x.Content)[0];
  }
  public async removeNewTemplate() {
    var ret = await this.UI.confirm("Turbo.Settings.EmailTemplate.headConfirmRemove", "Are you sure?", "Turbo.Settings.EmailTemplate.msgConfirmRemove", "Are you sure you want to delete this email template?")
    if (!ret) return;
    var ret1 = await this.UI.confirm("Turbo.Settings.EmailTemplate.headConfirmReallyRemove", "Are you really sure?", "Turbo.Settings.EmailTemplate.msgConfirmReallyRemove", "Are you really sure you want to delete this email template?")
    if (!ret1) return;
    this.data.Key = this.selectedKey;
    this.data.FriendlyName = this.friendlyName;

    var token = this.UI.beginLoading("T4.Settings.EmailTemplate.Remove.ldrRemoveEmailTemplate", "Removing email template", null);
    var res = await this.Api.delete("/Settings/DeleteEmailTemplate", { key: this.selectedKey, friendlyName: this.friendlyName });
    if (!res) return;
    this.UI.loaderCompleted(token);
    await this.UI.alert("T4.Settings.EmailTemplate.SuccessDeletion", "Success!", "T4.Settings.EmailTemplate.SuccessDeleteTemplateMsg", "The email template has been removed succesfully!");

    //Update the tabs
    await this.getContentTemplates();
    this.filteredFriendlyNames = await this.contentTemplates.filter(item => item.Key == this.selectedKey);
  }
  public async updateNewTemplate() {
    this.data.Key = this.selectedKey;
    this.data.FriendlyName = this.updatedFriendlyName;
    this.data.Content = this.editorContent;
    this.data.Id = this.selectedTemplateId;
    this.data.Condition = this.updatedCondition;

    var res = await this.Api.post("/Settings/SaveEmailTemplate", this.data);
    if (!res) return;
    await this.UI.alert("T4.Settings.EmailTemplate.SuccessUpdate", "Success!", "T4.Settings.EmailTemplate.SuccessUpdateTemplateMsg", "The email template has been updated succesfully!");

    //Update the tabs
    await this.getContentTemplates();
    this.filteredFriendlyNames = await this.contentTemplates.filter(item => item.Key == this.selectedKey);
  }

  //show the editor based on the format
  public onFormatChange(event: any) {
    if (event.value == 0) {
      this.showEditor = false;
    } else this.showEditor = true;
  }
}
